// extracted by mini-css-extract-plugin
export var alertIcon = "_r3-0";